
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule, instrumentModule, studyPatientContext} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";
import {MdbsCore} from "@/api/tsclient";
import {formatDate} from "@/auxillary/date-format";
import StudyPatientClient = MdbsCore.StudyPatientClient;
import StudyPatientRegisterPortalDto = MdbsCore.StudyPatientRegisterPortalDto;
import {eventBus} from "@/main";

@Component({
  name: 'IntegerField',
  components: {
    DataFieldBar,
    OkDialog,
    Hints
  },
})
export default class PatientPortalButtonField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";
  showCreateDialog = false;
  patientEmail = "";
  patientEmailRepeat = "";
  rules: any = {
    required: (v: string) => !!v || 'Wird benötigt.',
    email: (v: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(v) || 'Ungültige E-Mail-Adresse.';
    }
  }

  sameEmail(v: string) {
    return v === this.patientEmail || 'Die E-Mail-Adressen müssen identisch sein.'
  }

  get value() {
    return this.dataField.values.value
  }

  set value(value: string) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  get displayName() {
    return this.dataField?.displayName ?? ""
  }

  get wasIncluded(){
    return studyPatientContext?.studyPatient?.wasIncluded ?? false;
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get field() {
    return this.dataField;
  }

  get emailIsValid() {
    return this.rules.email(this.patientEmail) === true &&
        this.sameEmail(this.patientEmailRepeat) === true;
  }

  async sendMail() {
    this.showCreateDialog = false;

    try {

      const client = new StudyPatientClient();
      //TODO: Check result and handle error message if success == false
      await client.registerPatient(instrumentModule.instrument.patientId ?? "",
          new StudyPatientRegisterPortalDto({
            patientEMail: this.patientEmail,
          }))
      this.value = formatDate(new Date())
      await eventBus.$emit("save-instrument");

    } catch (e) {
      console.error(e)
    }

    this.patientEmail = "";
    this.patientEmailRepeat = "";
  }

}
